import { AlertCircle, CheckCircle, Info, XCircle } from 'lucide-react';
import { Toaster } from 'sonner';

import './AppToaster.css';

const icon = (Icon: typeof CheckCircle) => (
  <span className="app-toast-icon">
    <Icon aria-hidden="true" />
  </span>
);

/**
 * Where every toast appears and what it looks like: top right, the previous system's card (see
 * `AppToaster.css`), five seconds on screen.
 *
 * <p>Sonner is still what draws them, so a screen raises one with `toast.success(...)` as before; only the look
 * and the icons are replaced. `unstyled` drops sonner's own card so the classes below are the whole of it.
 */
export function AppToaster() {
  return (
    <Toaster
      position="top-right"
      offset={20}
      duration={5000}
      closeButton
      icons={{
        success: icon(CheckCircle),
        error: icon(XCircle),
        warning: icon(AlertCircle),
        info: icon(Info),
      }}
      toastOptions={{
        unstyled: true,
        classNames: {
          toast: 'app-toast',
          success: 'app-toast-success',
          error: 'app-toast-error',
          warning: 'app-toast-warning',
          info: 'app-toast-info',
        },
      }}
    />
  );
}
